// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1EHDy","header":"header___3nkDv","item":"item___3CIo-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/ItemCardCarousel.scss
// module id = orCU
// module chunks = 46